import { Link, Route, Routes } from "react-router-dom";
import { AggregateScoreType } from "~/operations";
import { FindingsPage } from "~/pages/findings";
import { FirewatchPage } from "~/components/FirewatchPage";
import { Check } from "~/pages/space/security/components/Check";
import { PolicyChecks } from "~/components/policy-gql/PolicyChecks";
import { EnablePolicies } from "~/pages/security/policies/enable-policies";
import { PoliciesAddDetailPage } from "~/pages/security/policies/policies-add-detail";
import { PoliciesAddQueryPage } from "~/pages/security/policies/policies-add-query";
import { PolicyAddDetailChecksPage } from "~/pages/security/policies/policy-add-detail-checks";
import { PolicyAddDetailPropertiesPage } from "~/pages/security/policies/policy-add-detail-properties";
import { PolicyDetailPropertiesPage } from "~/pages/security/policies/policy-detail-properties";
import { SpaceOrWorkspaceScope, SpaceScope } from "~/hooks/useScope";
import { ExposedAssetsSecurityPolicyTab } from "~/pages/space/vulnerabilities/components/exposed-assets/ExposedAssetsSecurityPolicyTab";

import { Policies } from "~/pages/security/policies/policies";
import { ExceptionsWrapper } from "~/components/policy-gql/PolicyExceptions";
import { PageLayout } from "~/routes";
import { ExceptionsPage } from "~/pages/findings/Exceptions";
import { PolicyPage } from "~/pages/space/PolicyPage/PolicyPage";

export type VulnerabilitiesRoutesProps = {
  scope: SpaceOrWorkspaceScope;
  spaceScope: SpaceScope;
};

export function FindingsRoutes({
  scope,
  spaceScope,
}: VulnerabilitiesRoutesProps) {
  return (
    <Routes>
      <Route element={<FindingsPage />}>
        <Route element={<PageLayout />}>
          <Route
            path="all"
            element={
              <FirewatchPage
                {...{
                  space: spaceScope,
                  scope,
                  pageType: "AllSecurityFindings",
                  docTitle: ["All Security Findings"],
                }}
              />
            }
          />

          <Route
            path="cves"
            element={
              <FirewatchPage
                {...{
                  space: spaceScope,
                  scope,
                  pageType: AggregateScoreType.Vulnerability,
                  docTitle: ["Vulnerabilities"],
                }}
              />
            }
          />

          <Route
            path="advisories"
            element={
              <FirewatchPage
                {...{
                  space: spaceScope,
                  scope,
                  pageType: AggregateScoreType.Advisory,
                  docTitle: ["Advisories"],
                }}
              />
            }
          />
          <Route path="policies">
            <Route
              index
              element={<Policies {...{ space: spaceScope, scope }} />}
            />
            <Route path="add">
              <Route
                index
                element={<EnablePolicies {...{ space: spaceScope }} />}
              />
              <Route
                path=":policyId"
                element={<PoliciesAddDetailPage {...{ space: spaceScope }} />}
              >
                <Route index element={<PolicyAddDetailChecksPage />} />
                <Route
                  path={"checks"}
                  element={<PolicyAddDetailChecksPage />}
                />
                <Route
                  path={"properties"}
                  element={<PolicyAddDetailPropertiesPage />}
                />
              </Route>
              <Route
                path=":policyId/queries/:queryId"
                element={<PoliciesAddQueryPage {...{ space: spaceScope }} />}
              />
            </Route>
            <Route
              path=":policyId"
              element={
                <PolicyPage
                  space={spaceScope}
                  scope={scope}
                  query={window.location.search}
                />
              }
            >
              <Route index element={<PolicyChecks />} />
              <Route path="checks" element={<PolicyChecks />} />
              <Route
                path="assets"
                element={<ExposedAssetsSecurityPolicyTab scope={scope} />}
              />
              <Route path="exceptions" element={<ExceptionsWrapper />} />
              <Route
                path="properties"
                element={<PolicyDetailPropertiesPage />}
              />
            </Route>
          </Route>
          <Route path="checks">
            <Route
              index
              element={
                <FirewatchPage
                  {...{
                    space: spaceScope,
                    scope,
                    pageType: AggregateScoreType.Check,
                    docTitle: ["Security Checks"],
                  }}
                />
              }
            />
          </Route>
          <Route path="exceptions">
            <Route index element={<ExceptionsPage space={spaceScope} />} />
          </Route>
        </Route>
        <Route
          path="check"
          element={<Check {...{ space: spaceScope, scope }} />}
          handle={{
            crumb: () => <Link to="/Check">Check</Link>,
          }}
        />
      </Route>
    </Routes>
  );
}
